var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my"},[(!_vm.is_login)?_c('div',{staticClass:"my-head"}):_vm._e(),(_vm.is_login)?_c('div',{staticClass:"user-info"},[_vm._m(0),_c('div',{staticClass:"my-info"},[_c('p',[_vm._v("电话: "+_vm._s(_vm.userInfo.tel))]),_c('p',[_vm._v("余额: "),_c('UserSurplus')],1)])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',[_c('div',{staticClass:"my-img"})])
}]

export { render, staticRenderFns }